import React, { useState } from "react";
import AirFreightForm from "../../../components/QuoteForm/Forms/AirFreightForm";
import CourierForm from "../../../components/QuoteForm/Forms/CourierForm";
import RailFreightForm from "../../../components/QuoteForm/Forms/RailFreightForm";
import RelocationForm from "../../../components/QuoteForm/Forms/RelocationForm";
import RoadTransportForm from "../../../components/QuoteForm/Forms/RoadTransportForm";
import SeaFreightForm from "../../../components/QuoteForm/Forms/SeaFreightForm";
import RequestModal from "../../../components/RequestModal";
import { toast, ToastContainer } from "react-toastify";
import { sendRequest } from "../../../services/RequestServices";
import { Helmet } from "react-helmet";

export default function GetQuotes() {
  const [formData, setFormData] = useState({
    service: "",
  });

  const [showRequestModal, setShowRequestModal] = useState(false);
  const [requestModalState, setRequestModalState] = useState({
    loading: false,
    error: null,
  });

  const [submittedServiceData, setSubmittedServiceData] = useState({
    submittedService: "",
    responseData: {}
  });


  const handleChange = (e) => {
    const updatedField = { [e.target.name]: e.target.value };
    setFormData(updatedField);
  };

  const services = [
    { value: "courier", label: "Courier" },
    { value: "airFreight", label: "Air Freight" },
    { value: "railFreight", label: "Rail Freight" },
    { value: "seaFreight", label: "Sea Freight" },
    { value: "roadtransport", label: "Road Transport" },
  ];

  const handleSubmit = async () => {
    setShowRequestModal(true);
    setRequestModalState(prev => ({ ...prev, loading: true, error: null }));

    try {
      const res = await sendRequest(formData.service, formData);
      setSubmittedServiceData(prev => ({...prev, submittedService: formData.service, data: res}));
      setRequestModalState(prev => ({...prev, loading: false, error: null }));
      const shouldShowModal =
        formData.service === "courier" &&
        Array.isArray(res?.rates) &&
        res.rates.length > 0;
      
      if (shouldShowModal) {
          setShowRequestModal(true); 
      } else {
          setShowRequestModal(false); 
          toast.success(`${formData.service} request submitted successfully!`);
      }
      setFormData({});
    } catch (error) {
      console.error(`Error submitting ${formData.service} request:`, error);
      setShowRequestModal(false);
      toast.error(`Error submitting ${formData.service} request:`, error);
    } finally {
      setRequestModalState(prev => ({...prev, loading: false, error: null }));
    }
  };

  return (
    <>
    <Helmet>
      <title>Get Quotes</title>
    </Helmet>
    <div className="container-fluid mt-4">
      <ToastContainer />
      <div className="dashboard-title mb-4">
        <h1 className="page-title h2">Request Quote</h1>
        <span className="text-muted">
          Quickly request a quote for any shipping service with ease.
        </span>
      </div>

      <div className="second-section">
        <form>
          <div className="row g-3">
            <div className="col-md-6">
              <label htmlFor="service" className="form-label">
                Select Service
              </label>
              <select
                id="service"
                name="service"
                value={formData.service}
                onChange={handleChange}
                className="form-select"
                style={{
                  border: "1px solid #ced4da",
                  borderRadius: "0.25rem",
                  padding: "0.375rem 0.75rem",
                  fontSize: "1rem",
                  lineHeight: "1.5",
                  color: "#495057",
                  backgroundColor: "#fff",
                  backgroundClip: "padding-box",
                  transition:
                    "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                }}
              >
                <option value="">- Select -</option>
                {services.map((service) => (
                  <option key={service.value} value={service.value}>
                    {service.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="mt-4">
            {formData?.service === "courier" && (
              <CourierForm
                handleSubmit={handleSubmit}
                formData={formData}
                setFormData={setFormData}
              />
            )}
            {formData?.service === "airFreight" && (
              <AirFreightForm
                handleSubmit={handleSubmit}
                formData={formData}
                setFormData={setFormData}
              />
            )}
            {formData?.service === "seaFreight" && (
              <SeaFreightForm
                handleSubmit={handleSubmit}
                formData={formData}
                setFormData={setFormData}
              />
            )}
            {formData?.service === "railFreight" && (
              <RailFreightForm
                handleSubmit={handleSubmit}
                formData={formData}
                setFormData={setFormData}
              />
            )}
            {formData?.service === "roadtransport" && (
              <RoadTransportForm
                handleSubmit={handleSubmit}
                formData={formData}
                setFormData={setFormData}
              />
            )}
            {formData?.service === "relocation" && (
              <RelocationForm
                handleSubmit={handleSubmit}
                formData={formData}
                setFormData={setFormData}
                
              />
            )}
          </div>
        </form>
      </div>

      {/* You can add the Table component here if needed */}

      <RequestModal
        show={showRequestModal}
        onClose={() => setShowRequestModal(false)}
        loading={requestModalState.loading}
        error={requestModalState.error}
        courier={submittedServiceData.submittedService === "courier"}
        data={submittedServiceData.data}
      />
    </div>
    </>
  );
}
